/**
 * FeaturedCarousel Component
 * Wrapper around the generic Carousel for displaying featured rituals
 */

import { RitualCard, type RitualCardProps } from "@/components/cards/ritualCard"
import { Carousel, type ResponsiveItemsConfig } from "@/components/carousel/Carousel"
export interface FeaturedCarouselProps {
  rituals: RitualCardProps[]
  itemsPerScreen?: ResponsiveItemsConfig // Optional responsive configuration
  className?: string
}

export function FeaturedCarousel({ rituals, itemsPerScreen, className }: FeaturedCarouselProps) {
  return (
    <Carousel
      data={rituals}
      className={className}
      renderItem={ritual => <RitualCard {...ritual} />}
      itemsPerScreen={itemsPerScreen}
      contentClassName="h-[260px] md:h-[600px]"
      itemWidth="min(1200px, 100%)"
    />
  )
}
